/* eslint-disable no-param-reassign */
export function formatDecimalPlaces(data: any) {    
    for (const key of Object.keys(data)) {
        const value = data[key];
        if(typeof data[key] == 'number') {
            data[key] = value.toFixed(2).replace(/[.,]00$/, "");
        } else if (typeof data[key] == 'object') {            
            data[key] = formatDecimalPlaces(data[key])
        }
      }
      return data;
}